module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_600.f5cb251.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/fullscreen-image_hero_600.png
// module id = UH9k
// module chunks = 0